import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

import type { CartProduct } from "@shared/types/ProductLine";

interface PickupOrDeliveryEntityParams {
  selection: string;
  warehouseId: number | null;
  warehouseLocationCode: string | null;
  inventoryId: number;
  distributorId: number;
}
export class PickupOrDeliveryEntity extends BaseEntityClass {
  selection: string;
  warehouseId: number | null;
  warehouseLocationCode: string | null;
  inventoryId: number;
  distributorId: number;
  constructor(params: PickupOrDeliveryEntityParams) {
    super();
    this.type = "pickup_or_delivery";
    this.entity_version = 3;
    this.selection = params.selection;
    this.warehouseId = params.warehouseId;
    this.warehouseLocationCode = params.warehouseLocationCode;
    this.inventoryId = params.inventoryId;
    this.distributorId = params.distributorId;
  }

  static fromCartProduct(cartProduct: CartProduct): PickupOrDeliveryEntity {
    const entityParams: PickupOrDeliveryEntityParams = {
      distributorId: cartProduct.distributor_id,
      inventoryId: cartProduct.inventory?.id,
      warehouseId: cartProduct.warehouse_id,
      warehouseLocationCode: cartProduct.warehouse_location_code,
      selection: cartProduct.warehouse_id ? "pickup" : "delivery",
    };

    const entity = new PickupOrDeliveryEntity(entityParams);
    return entity;
  }
}
